import React from 'react';
import moment from 'moment/moment';
import { Kpis, fieldWindow } from './surveyMetrics';

type Props = { kpis: Kpis; medianLoi?: number | null; publishDate?: string; expiryDate?: string };

const Tile: React.FC<{ label: string; testId?: string }> = ({ label, testId, children }) => (
  <div className="col-6 mb-3">
    <div className="dx-kpi" data-testid={testId}>
      <div className="dx-kpi-label">{label}</div>
      {children}
    </div>
  </div>
);

export const KpiTiles: React.FC<Props> = ({ kpis, medianLoi, publishDate, expiryDate }) => {
  const { daysLeft } = fieldWindow(publishDate, expiryDate);
  const fmt = (d?: string) => (d ? moment(d).format('MM/DD/YYYY') : '-');
  return (
    <div className="row">
      <Tile label="Completes">
        <div className="dx-kpi-value">{kpis.completes}</div>
        <div className="progress"><div className="progress-bar" style={{ width: `${kpis.pctComplete}%` }} /></div>
      </Tile>
      <Tile label="Quota">
        <div className="dx-kpi-value">{kpis.quota}</div>
        <small className="text-muted">{Math.round(kpis.pctComplete)}% complete</small>
      </Tile>
      <Tile label="Hits"><div className="dx-kpi-value">{kpis.hits}</div></Tile>
      <Tile label="IR %"><div className="dx-kpi-value">{kpis.irPct.toFixed(2)}</div></Tile>
      <Tile label="Dropout %"><div className="dx-kpi-value">{kpis.dropoutPct.toFixed(2)}</div></Tile>
      <Tile label="Median LOI" testId="kpi-loi">
        <div className="dx-kpi-value">
          <span>{medianLoi === null || medianLoi === undefined ? '-' : Number(medianLoi).toFixed(2)}</span>{' '}
          <small className="text-muted">min</small>
        </div>
      </Tile>
      <div className="col-12 mb-3">
        <div className="dx-kpi">
          <div className="dx-kpi-label">Field window</div>
          <div className="font-weight-bold">{fmt(publishDate)} – {fmt(expiryDate)}</div>
          {daysLeft !== null && <small className="text-muted">{daysLeft} day(s) left</small>}
        </div>
      </div>
    </div>
  );
};
